import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import { passValidationData } from 'constants/passwordValidation';

const styles = {
  container: {
    display: 'grid',
    gap: 1,
    padding: 0,
    gridTemplateColumns: {
      xs: '1fr',
      lg: 'repeat(2, 1fr)',
      xxl: 'repeat(3, 1fr)',
    },
  },
  item: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
  },
  itemValid: ({ palette }) => ({
    color: palette.colors.darkGrey,
  }),
  dot: ({ palette }) => ({
    width: 8,
    height: 8,
    flexShrink: 0,
    borderRadius: '50%',
    backgroundColor: palette.info.main,
  }),
  dotValid: ({ palette }) => ({
    backgroundColor: palette.colors.darkGrey,
  }),
};

const PasswordValidationInfo = ({ passwordValidation, prefix, sx = {} }) => {
  return (
    <Box sx={[styles.container, ...(Array.isArray(sx) ? sx : [sx])]}>
      {passValidationData.map(({ key, caption }) => {
        const isValid = passwordValidation[key];

        return (
          <Typography
            key={key}
            component="p"
            variant="body2"
            id={`${prefix}-pass-validation-${key}`}
            sx={[styles.item, isValid && styles.itemValid]}
          >
            <Box component="span" sx={[styles.dot, isValid && styles.dotValid]} />
            {caption}
          </Typography>
        );
      })}
    </Box>
  );
};

PasswordValidationInfo.propTypes = {
  prefix: PropTypes.string.isRequired,
  passwordValidation: PropTypes.objectOf(PropTypes.bool.isRequired).isRequired,
  sx: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.func])),
  ]),
};
export default PasswordValidationInfo;
